export const PRIVACY = {
  GREEN: { label: "VERDE", desc: "Contattabile", allowed: true, cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  YELLOW: { label: "GIALLO", desc: "Consenso da verificare", allowed: false, cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  RED: { label: "ROSSO", desc: "Non contattare", allowed: false, cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  BLACK: { label: "NERO", desc: "Blacklist / GDPR", allowed: false, cls: "bg-slate-900 text-slate-100 border-slate-700", dot: "bg-slate-400" },
};

export const PROPERTY_STATUSES = [
  "Nuova opportunità",
  "In valutazione",
  "In negoziazione",
  "Acquistata",
  "In ristrutturazione",
  "In vendita",
  "Venduta",
  "In attesa di incasso",
  "Incassata / Conclusa",
  "Scartata",
];

export const PROPERTY_STATUS_CLS = {
  "Nuova opportunità": "bg-slate-100 text-slate-700 border-slate-200",
  "In valutazione": "bg-blue-50 text-blue-700 border-blue-200",
  "In negoziazione": "bg-amber-50 text-amber-700 border-amber-200",
  "Acquistata": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "In ristrutturazione": "bg-orange-50 text-orange-700 border-orange-200",
  "In vendita": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Venduta": "bg-violet-50 text-violet-700 border-violet-200",
  "In attesa di incasso": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "Incassata / Conclusa": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Scartata": "bg-slate-200 text-slate-600 border-slate-300",
};
export const PROPERTY_TYPES = ["Appartamento", "Villa", "Rustico/Casale", "Intero Stabile", "Terreno", "Ufficio", "Negozio"];
export const OPERATION_TYPES = ["Acquisto classico", "Cessione compromesso", "Saldo e stralcio / Asta"];
export const ENERGY_CLASSES = ["A4", "A3", "A2", "A1", "B", "C", "D", "E", "F", "G", "Non disponibile"];
export const EXPOSURES = ["Nord", "Sud", "Est", "Ovest", "Nord-Est", "Nord-Ovest", "Sud-Est", "Sud-Ovest", "Doppia esposizione", "Tripla/Quadrupla esposizione"];
export const HEATING_TYPES = ["Autonomo", "Centralizzato", "Pompa di calore", "Teleriscaldamento", "Assente"];
export const GARDEN_TYPES = ["Nessuno", "Privato", "Condominiale"];
export const CONDITIONS = ["Nuovo / Ristrutturato", "Ottimo", "Buono", "Discreto", "Da ristrutturare parzialmente", "Da ristrutturare"];

export const QUOTE_STATUSES = {
  Draft: { label: "Bozza", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  Sent: { label: "Inviato", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  Accepted: { label: "Accettato", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  Rejected: { label: "Rifiutato", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  Expired: { label: "Scaduto", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const FOLLOWUP_TYPES = ["Chiamata", "Email", "Sopralluogo", "Riunione", "Documento", "Altro"];
export const FOLLOWUP_STATUSES = ["Aperto", "In ritardo", "Chiuso"];

export const SOURCES = ["Passaparola", "Portale Immobiliare", "Sito Web", "Fiera Immobiliare", "LinkedIn", "Chiamata a freddo", "Altro"];

export const DECISION = {
  BUY: { label: "ACQUISTA", cls: "bg-emerald-600 text-white", badge: "bg-emerald-100 text-emerald-800 border-emerald-300", border: "border-l-emerald-600" },
  NEGOTIATE: { label: "TRATTA / ABBASSA PREZZO", cls: "bg-amber-500 text-white", badge: "bg-amber-100 text-amber-800 border-amber-300", border: "border-l-amber-500" },
  DO_NOT_BUY: { label: "NON ACQUISTARE", cls: "bg-rose-600 text-white", badge: "bg-rose-100 text-rose-800 border-rose-300", border: "border-l-rose-600" },
};

export const DOC_CHECKLIST = ["Visura Catastale", "Planimetria", "APE", "Atto di Provenienza", "Concessione Edilizia"];

export const CONTACT_ROLES = ["Proprietario", "Acquirente interessato", "Referente"];
export const CONTACT_ROLE_CLS = {
  "Proprietario": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Acquirente interessato": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Referente": "bg-slate-100 text-slate-700 border-slate-200",
};

export const PROPOSAL_STATUSES = [
  "Proposta da preparare", "Proposta inviata", "In attesa di risposta", "Controproposta ricevuta",
  "Proposta accettata", "Verifica documenti", "Preliminare firmato", "Rogito programmato", "Acquistato",
  "Rifiutata", "Scaduta/Ritirata",
];

export const PROPOSAL_PROGRESS_ORDER = PROPOSAL_STATUSES.slice(0, 9);

export const PROPOSAL_STATUS_CLS = {
  "Proposta da preparare": "bg-slate-100 text-slate-700 border-slate-200",
  "Proposta inviata": "bg-blue-50 text-blue-700 border-blue-200",
  "In attesa di risposta": "bg-sky-50 text-sky-700 border-sky-200",
  "Controproposta ricevuta": "bg-amber-50 text-amber-700 border-amber-200",
  "Proposta accettata": "bg-teal-50 text-teal-700 border-teal-200",
  "Verifica documenti": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Preliminare firmato": "bg-violet-50 text-violet-700 border-violet-200",
  "Rogito programmato": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "Acquistato": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Rifiutata": "bg-rose-50 text-rose-700 border-rose-200",
  "Scaduta/Ritirata": "bg-slate-200 text-slate-600 border-slate-300",
  "Convertita in operazione": "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function proposalProgress(status) {
  const i = PROPOSAL_PROGRESS_ORDER.indexOf(status);
  if (i >= 0) return { pct: Math.round((i / 8) * 100), kind: status === "Acquistato" ? "done" : "progress" };
  if (status === "Convertita in operazione") return { pct: 100, kind: "done" };
  if (status === "Rifiutata") return { pct: 100, kind: "negative" };
  if (status === "Scaduta/Ritirata") return { pct: 100, kind: "warning" };
  return { pct: 0, kind: "progress" };
}

export const OPERATION_STATUSES = [
  "Operazione avviata", "Documenti in verifica", "Preliminare da preparare", "Preliminare firmato",
  "Rogito programmato", "Acquisto completato", "In ristrutturazione / valorizzazione",
  "Pronta alla vendita", "In vendita", "Venduta", "Incasso programmato", "Incasso completato",
];
export const OPERATION_SKIPPABLE = ["In ristrutturazione / valorizzazione", "Pronta alla vendita"];

// Type-specific pipelines. Types not listed use OPERATION_STATUSES (default).
export const OPERATION_PIPELINES = {
  "Cessione compromesso": [
    "Operazione avviata", "Documenti in verifica", "Compromesso firmato",
    "Verifica cedibilità del compromesso", "Cessionario individuato", "Trattativa in corso",
    "Accordo economico definito", "Cessione firmata", "Adempimenti completati",
    "Incasso programmato", "Incasso completato",
  ],
};
export function pipelineFor(type) { return OPERATION_PIPELINES[type] || OPERATION_STATUSES; }
export const ALL_OPERATION_STATUSES = Array.from(new Set([...OPERATION_STATUSES, ...Object.values(OPERATION_PIPELINES).flat()]));

export const OPERATION_STATUS_CLS = {
  "Operazione avviata": "bg-slate-100 text-slate-700 border-slate-200",
  "Documenti in verifica": "bg-blue-50 text-blue-700 border-blue-200",
  "Preliminare da preparare": "bg-sky-50 text-sky-700 border-sky-200",
  "Preliminare firmato": "bg-violet-50 text-violet-700 border-violet-200",
  "Rogito programmato": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "Acquisto completato": "bg-teal-50 text-teal-700 border-teal-200",
  "In ristrutturazione / valorizzazione": "bg-amber-50 text-amber-700 border-amber-200",
  "Pronta alla vendita": "bg-lime-50 text-lime-700 border-lime-200",
  "In vendita": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Venduta": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Incasso programmato": "bg-orange-50 text-orange-700 border-orange-200",
  "Incasso completato": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Compromesso firmato": "bg-violet-50 text-violet-700 border-violet-200",
  "Verifica cedibilità del compromesso": "bg-sky-50 text-sky-700 border-sky-200",
  "Cessionario individuato": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "Trattativa in corso": "bg-amber-50 text-amber-700 border-amber-200",
  "Accordo economico definito": "bg-lime-50 text-lime-700 border-lime-200",
  "Cessione firmata": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Adempimenti completati": "bg-teal-50 text-teal-700 border-teal-200",
};
export function operationProgress(status, type) {
  const pipe = pipelineFor(type);
  const i = pipe.indexOf(status);
  const n = pipe.length - 1;
  if (i < 0) return { pct: 0, kind: "progress" };
  return { pct: Math.round((i / n) * 100), kind: status === "Incasso completato" ? "done" : "progress" };
}
